import { observable } from "mobx";
import { inject, observer, Provider } from "mobx-react";
import React = require("react");
import { RootStore } from "../../core/stores/RootStore";
import { RouteComponentProps } from "react-router-dom";
import { TableReservationStore } from "./core/stores/TableReservationStore";
import { TableReservation } from "./components/TableReservation";

interface MatchParams {
  id: string;
}

interface IProps extends RouteComponentProps<MatchParams> {
  RootStore?: RootStore;
}

interface Stores {
  TableReservationStore: TableReservationStore;
}

@inject("RootStore")
@observer
export class TableReservationPage extends React.Component<IProps> {
  private stores: Stores;

  constructor(props: IProps) {
    super(props);
    console.log("this.props.match.params.id", this.props.match.params);

    this.stores = {
      TableReservationStore: new TableReservationStore(props.RootStore),
    };
  }

  async componentDidMount() {
    this.stores.TableReservationStore.Init();
  }

  public render() {
    return (
      <Provider {...this.stores}>
        <TableReservation />
      </Provider>
    );
  }
}
